import type { Comment } from 'component/comment';
import { HelpBubble } from 'component/help';
import type { QuestionConfig } from 'structure/question';
import { useGlobalParams } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

// Extended comment type for entry points functionality
export type CommentWithEntryPoints = Comment & {
    entryUrl?: string;
    entryPoints?: Array<{ url: string }>;
};
export const SingleResponseHelpFeature: Feature<QuestionConfig, {}> = {
    name: 'Single Response Toast',
    key: 'single_response_help',
    dev: true,
    providesConfig: {
        myAnswerBottomWidgets: [HelpIfDifferentUrl],
    },
};

export type HelpIfDifferentUrlProps = { comment: CommentWithEntryPoints };

export function HelpIfDifferentUrl({ comment }: HelpIfDifferentUrlProps) {
    const { entryUrl } = useGlobalParams();
    if (!(comment as CommentWithEntryPoints).entryPoints && !(comment as CommentWithEntryPoints).entryUrl) return null;
    const commentUrl = (comment as CommentWithEntryPoints)?.entryUrl ?? (comment as CommentWithEntryPoints)?.entryPoints?.[0]?.url;
    const entryPointForHere = entryUrl == commentUrl;
    if (entryPointForHere) return null;

    return (
        <HelpBubble
            condition={true}
            helpKey='single-response'
            label={t('Update your previous response with fresh insights')}
            padTop={12}
            pointer
            titleLabel={t('Same question, new article?')}
        />
    );
}
